import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmCancelModalContent } from './+model/confirm-cancel-modal-content';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ngf-confirm-cancel-modal',
    styleUrls: ['./confirm-cancel-modal.component.scss'],
    templateUrl: './confirm-cancel-modal.component.html',
    standalone: false
})
export class ConfirmCancelModalComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmCancelModalContent,
              private dialogRef: MatDialogRef<ConfirmCancelModalComponent>) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
